import { useExportStore } from '../store/export.store';

import { ExportRunner } from './export-runner';

/**
 * App-level watcher for enriched-product exports. Mounted once in the tenant
 * layout so its SSE streams + progress toasts survive navigation between pages.
 * Renders one headless runner per tracked export; renders nothing visible itself.
 */
export function ExportProgressManager() {
  const sessions = useExportStore((s) => s.sessions);
  return (
    <>
      {Object.values(sessions).map((session) => (
        <ExportRunner key={session.exportId} session={session} />
      ))}
    </>
  );
}
